import {
  campaignStepSchema,
  customizeAdStepSchema,
  detailsStepSchema,
  selectVideoOnlyStepSchema,
  targetTypeStepSchema,
} from '../-schema';
import type { AdWizardFormData } from '../-schema';
import type { WizardStep } from './-steps';

// Booking-funnel campaigns choose Service or Packages before Details.
// Other campaigns retain Details → Content → Preview after campaign selection.
const MOBILE_STEPS: WizardStep[] = [
  { id: 'campaign', schema: campaignStepSchema },
  {
    id: 'target-type',
    schema: targetTypeStepSchema,
    showIf: (_data, context) =>
      context?.selectedCampaignFollowUpType === 'booking_funnel',
  },
  { id: 'details', schema: detailsStepSchema },
  { id: 'select-media', schema: selectVideoOnlyStepSchema },
  { id: 'customize', schema: customizeAdStepSchema },
];

export function getMobileActiveSteps(
  data: Partial<AdWizardFormData>,
  context?: {
    selectedCampaignFollowUpType?: string;
    /** When campaign is already chosen via URL, skip the in-wizard step. */
    skipCampaign?: boolean;
  }
): WizardStep[] {
  return MOBILE_STEPS.filter((s) => {
    if (context?.skipCampaign && s.id === 'campaign') {
      return false;
    }
    return !s.showIf || s.showIf(data, context);
  });
}
